import { render, staticRenderFns } from "./RegistrarBajaSim.vue?vue&type=template&id=1e88e5a4&"
import script from "./RegistrarBajaSim.vue?vue&type=script&lang=ts&"
export * from "./RegistrarBajaSim.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrarBajaSim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports